// import {option_window,option_pie,option_pie2} from '@/options/option'
import moment from "moment";
import axios from "axios";
import HighCharts from "highcharts";
import {
  getSingleStationData,
  getPollutionLevel,
  getStationHistory,
  getStationAlarmHistory
} from "@/api/api";
import { time_unit_info, time_range_std } from "./common";
import { getgradientcolor } from "@/utils/pmutils";
import _ from "lodash";

function getBoundary(map, city) {
  var bdary = new BMap.Boundary();
  bdary.get(city, function(rs) {
    //for循环都删除掉了，只剩下这个
    //网上查了下，东西经南北纬的范围
    var EN_JW = "180, 90;"; //东北角
    var NW_JW = "-180,  90;"; //西北角
    var WS_JW = "-180, -90;"; //西南角
    var SE_JW = "180, -90;"; //东南角
    //4.添加环形遮罩层
    var ply1 = new BMap.Polygon(
      rs.boundaries[0] + SE_JW + SE_JW + WS_JW + NW_JW + EN_JW + SE_JW,
      {
        strokeColor: "none",
        fillColor: "#081734",
        fillOpacity: 1,
        strokeOpacity: 0.5
      }
    ); //建立多边形覆盖物

    map.addOverlay(ply1);
    //5. 给目标行政区划添加边框，其实就是给目标行政区划添加一个没有填充物的遮罩层
    var ply = new BMap.Polygon(rs.boundaries[0], {
      strokeWeight: 2,
      strokeColor: "#00f",
      fillColor: ""
    });
    map.addOverlay(ply);
    // map.setViewport(ply.getPath());    //调整视野
  });
}

function drawBoundary(map, city) {
  var bdary = new BMap.Boundary();
  bdary.get(city, function(rs) {
    //获取行政区域
    var count = rs.boundaries.length; //行政区域的点有多少个
    if (count === 0) {
      console.log("未能获取当前输入行政区域");
      return;
    }
    var pointArray = [];
    for (var i = 0; i < count; i++) {
      window._ply = new BMap.Polygon(rs.boundaries[i], {
        strokeWeight: 2,
        strokeColor: "#ff0000",
        fillColor: ""
      }); //建立多边形覆盖物
      map.addOverlay(_ply); //添加覆盖物
    }
  });
}

function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}

function getWindDirectionDesc(degree) {
  if (degree) {
    let descs = ["北", "东北", "东", "东南", "南", "西南", "西", "西北"];
    let index = Math.floor((degree + 22.5) / 45) % 8;
    return descs[index];
  } else {
    return "";
  }
}

function fullPage() {
  var docElm = document.documentElement;
  if (docElm.requestFullscreen) {
    docElm.requestFullscreen();
  }

  //FireFox
  else if (docElm.mozRequestFullScreen) {
    docElm.mozRequestFullScreen();
  }

  //Chrome等
  else if (docElm.webkitRequestFullScreen) {
    docElm.webkitRequestFullScreen();
  }

  //IE11
  else if (elem.msRequestFullscreen) {
    elem.msRequestFullscreen();
  }

  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitCancelFullScreen) {
    document.webkitCancelFullScreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
}

function checkEnd(t) {
  let t_now = moment().unix();
  if (t > t_now) {
    return t_now;
  } else {
    return t;
  }
}

function getWindowContent(
  station_name,
  station_data,
  map,
  station_id,
  time_type,
  data_time,
  childs
) {
  function draw_window_chart(timep = null) {
    let start = data_time - 1 * 3600;
    let end = checkEnd(data_time + 1 * 3600);
    let time_type = "1m";

    if (timep == "hour") {
      time_type = "1h";
      start = data_time - 24 * 3600 * 2;
      end = checkEnd(data_time + 24 * 3600 * 2);
    }
    if (timep == "day") {
      time_type = "1d";
      start = data_time - 24 * 3600 * 10;
      end = checkEnd(data_time + 24 * 3600 * 10);
    }

    getStationHistory(time_type, station_id, start, end).then(function(resp) {
      getStationAlarmHistory(station_id, start, end).then(function(x) {
        let alarms = x.data;
        let data = resp.data.datas;
        let pm25_data = [];
        let pm10_data = [];
        for (let i of data) {
          pm25_data.push([i[0] * 1000, Math.round(i[1])]);
          pm10_data.push([i[0] * 1000, Math.round(i[2])]);
        }
        let series = [
          { name: "PM₂.₅", data: pm25_data },
          { name: "PM₁₀", data: pm10_data }
        ];
        if (alarms.length > 0) {
          for (let a of alarms) {
            let alarm_type = a.type.slice(0, 4);
            let alarm_start = moment(a.start_data_time).unix();
            let alarm_end = a.end_data_time;
            if (alarm_end) {
              alarm_end = moment(a.end_data_time).unix();
            } else {
              alarm_end = moment().unix();
            }
            let filter_data = pm25_data;
            if (alarm_type == "pm10") {
              filter_data = pm10_data;
            }
            let alarm_series_data = _.filter(filter_data, function(x) {
              return x[0] / 1000 >= alarm_start && x[0] / 1000 <= alarm_end;
            });
            series.push({
              name: a.name,
              data: alarm_series_data,
              color: "red"
            });
          }
        }
        option_window.series = series;
        let chart = HighCharts.chart("window_chart", option_window);
        chart.xAxis[0].removePlotLine("plot-line-1");
        chart.xAxis[0].addPlotLine({
          //在x轴上增加
          value: data_time * 1000, //在值为2的地方
          width: 1, //标示线的宽度为2px
          color: "white", //标示线的颜色
          id: "plot-line-1" //标示线的id，在删除该标示线的时候需要该id标示
        });
      });
    });
  }
  function draw_pie_chart(station_id) {
    getPollutionLevel(station_id).then(x => {
      let d1 = x.data[0];
      let d2 = x.data[1];
      option_pie.series = [
        {
          type: "pie",
          name: "",
          data: [
            ["优", parseInt(d1.pollution_level1)],
            ["良", parseInt(d1.pollution_level2)],
            ["轻度污染", parseInt(d1.pollution_level3)],
            ["中度污染", parseInt(d1.pollution_level4)],
            ["重度污染", parseInt(d1.pollution_level5)],
            ["严重污染", parseInt(d1.pollution_level6)]
          ],
          colors: [
            "rgb(92,231,48)",
            "rgb(255,245,74)",
            "rgb(255,170,0)",
            "rgb(255,64,26)",
            "#CD3700",
            "rgb(0,0,0)"
          ]
        }
      ];
      option_pie2.series = [
        {
          type: "pie",
          name: "",
          data: [
            ["优", parseInt(d2.pollution_level1)],
            ["良", parseInt(d2.pollution_level2)],
            ["轻度污染", parseInt(d2.pollution_level3)],
            ["中度污染", parseInt(d2.pollution_level4)],
            ["重度污染", parseInt(d2.pollution_level5)],
            ["严重污染", parseInt(d2.pollution_level6)]
          ],
          colors: [
            "rgb(92,231,48)",
            "rgb(255,245,74)",
            "rgb(255,170,0)",
            "rgb(255,64,26)",
            "#CD3700",
            "rgb(0,0,0)"
          ]
        }
      ];
      HighCharts.chart("chart5", option_pie);
      HighCharts.chart("chart6", option_pie2);
    });
  }
  window.draw_window_chart = draw_window_chart;
  var content = ` 
   <div style="margin:0;line-height:20px;padding:2px;">                 
     <p>名称:${station_name}</p>   
     `;
  var height = 520;
  let pm10_color = getPMInfo(station_data.pm10, "pm10");
  let pm25_color = getPMInfo(station_data.pm25, "pm25");
  var content = `
  <div class="field_height">
    <div class="tb_label">PM₂.₅:</div><div class="tb_value" style="background: ${pm25_color.bgcolor};color:${pm10_color.fgcolor} ">${station_data.pm25}</div>
    <div class="tb_label">PM₁₀:</div><div class="tb_value" style="color:black;background:${pm10_color.bgcolor};color:${pm10_color.fgcolor}">${station_data.pm10}</div>
  </div>
  `;
  if (station_data.wendu || station_data.shidu) {
    height += 40;
    content += `<div class="field_height">
    <div class="tb_label">温度:</div><div class="tb_value">${station_data.wendu}</div>
    <div class="tb_label">湿度:</div><div class="tb_value">${station_data.shidu}</div>
  </div>
  `;
  }
  if (station_data.wind_speed || station_data.wind_direction) {
    height += 40;
    content += `<div class="field_height">
    <div class="tb_label">风速:</div><div class="tb_value">${
      station_data.wind_speed
    }</div>
    <div class="tb_label">风向:</div><div class="tb_value">${getWindDirectionDesc(
      station_data.wind_direction
    )}</div>
  </div>`;
  }
  content += `
  <div class="field_height">
    <div class="tb_label">时间:</div><div class="tb_value" style="border:none">${station_data.time}</div>
  </div>
  <div style="padding-left:20px">
    <button onclick="draw_window_chart()" class="mini ui inverted basic button">实时</button>
    <button onclick="draw_window_chart('hour')" class="mini ui inverted basic button">时均</button>
    <button onclick="draw_window_chart('day')" class="mini ui inverted basic button">日均</button>
  </div>
  <div style="height:180px" id="window_chart"></div>
  
  `;
  // <div style="height:240px;display:inline-block;width:49%" id="chart5"></div>
  // <div style="height:240px;display:inline-block;width:49%" id="chart6"></div>
  let searchInfoWindow = new BMapLib.SearchInfoWindow(map, content, {
    title: station_name, //标题
    width: 500, //宽度
    height: height, //高度
    panel: "panel", //检索结果面板
    enableAutoPan: true, //自动平移
    searchTypes: []
  });
  draw_window_chart();
  // draw_pie_chart(station_id)
  return searchInfoWindow;
}

function openMapWindow(
  station_id,
  station_name,
  Lng,
  Lat,
  map,
  data_time,
  time_type,
  childs
) {
  var p = new BMap.Point(Lng, Lat);
  if (data_time == 0) {
    let searchInfoWindow = getWindowContent(
      station_name,
      { pm25: "", pm10: "", time: "" },
      map,
      station_id,
      time_type,
      data_time
    );
    searchInfoWindow.open(p);
    return;
  }
  let data_time_str = moment(data_time * 1000).format("YYYY-MM-DD HH:mm:ss");
  getSingleStationData(time_type, station_id, data_time_str)
    .then(x => {
      if (x.data.status == "ok") {
        let station_data = x.data.result;
        if (station_data.pm25) {
          station_data.pm25 = Math.round(station_data.pm25);
        }
        if (station_data.pm10) {
          station_data.pm10 = Math.round(station_data.pm10);
        }
        if (station_data.wendu) {
          station_data.wendu = Math.round(station_data.wendu);
        }
        if (station_data.shidu) {
          station_data.shidu = Math.round(station_data.shidu);
        }
        let searchInfoWindow = getWindowContent(
          station_name,
          station_data,
          map,
          station_id,
          time_type,
          data_time,
          childs
        );
        searchInfoWindow.open(p);
      }
    })
    .catch(function(e) {
      let searchInfoWindow = getWindowContent(
        station_name,
        { pm25: "", pm10: "", time: "" },
        map,
        station_id,
        time_type,
        data_time,
        childs
      );
      searchInfoWindow.open(p);
    });
}

function time_add_by_type(t, time_type, play_speed) {
  if (time_type == "min") {
    t += 60 * 1000 * play_speed;
  }
  if (time_type == "hour") {
    t += 3600 * 1000 * play_speed;
  }
  if (time_type == "day") {
    t += 3600 * 24 * 1000 * play_speed;
  }
  if (time_type == "week") {
    t += 3600 * 24 * 7 * 1000 * play_speed;
  }
  if (time_type == "month") {
    t +=
      moment(t)
        .add(1, "month")
        .unix() *
      1000 *
      play_speed;
  }
  if (time_type == "year") {
    t +=
      moment(t)
        .add(1, "year")
        .unix() *
      1000 *
      play_speed;
  }
  return t;
}

function check_time(t, t_unit) {
  let v = t / t_unit;
  if (Number.isInteger(v)) {
    return t;
  } else {
    return parseInt(v + 1) * t_unit;
  }
}

function get_recent_start(t, time_type) {
  if (time_type == "min") {
    t = check_time(t, 60 * 1000);
  }
  if (time_type == "hour") {
    t = check_time(t, 3600 * 1000);
  }
  if (time_type == "day") {
    t =
      moment(
        moment(t + 3600 * 24 * 1000).format("YYYY-MM-DD 00:00:00")
      ).unix() * 1000;
  }
  if (time_type == "week") {
    t =
      moment(moment(moment(t).day(1)).format("YYYY-MM-DD 00:00:00")).unix() *
      1000;
  }
  if (time_type == "month") {
    t = moment(moment(t).format("YYYY-MM-01 00:00:00")).unix() * 1000;
  }
  if (time_type == "year") {
    t = moment(moment(t).format("YYYY-01-01 00:00:00")).unix() * 1000;
  }
  return t;
}

function check_time_type(start, end, time_type) {
  // let time_unit = time_unit_info[time_type]
  if (time_type == "real") {
    time_type = "min";
  }
  let time_dif_min = (end - start) / 60 / 1000;
  for (let i in time_range_std) {
    let r = time_range_std[i];
    if (time_dif_min >= r[0] && time_dif_min <= r[1]) {
      time_type = i;
      break;
    }
  }
  return time_type;
}

function check_time_range(start, end, time_type) {
  if (time_type == "real") {
    time_type = "min";
  }
  let time_unit = time_unit_info[time_type];
  let point_counts = (end - start) / 1000 / time_unit;
  let point_counts_min = 4;
  let point_counts_max = 2880;
  if (point_counts > point_counts_max) {
    end = start + time_unit * point_counts_max * 1000 + 1000;
  }
  if (point_counts < point_counts_min) {
    end = start + time_unit * point_counts_min * 1000 + 1000;
  }
  let t_now = Date.parse(new Date());
  /* if (end > t_now){
    end = t_now
    start = end - time_unit*point_counts_min*1000
  } */
  return { start: start, end: end };
}

function get_time_range_by_point(time_point, time_type) {
  let start = time_point - 2 * 3600;
  let end = checkEnd(time_point + 2 * 3600);

  if (time_type == "hour") {
    start = time_point - 24 * 3600 * 2;
    end = checkEnd(time_point + 24 * 3600 * 2);
  }
  if (time_type == "day") {
    start = time_point - 24 * 3600 * 10;
    end = checkEnd(time_point + 24 * 3600 * 10);
  }
  if (time_type == "week") {
    start = time_point - 24 * 3600 * 7 * 8;
    end = checkEnd(time_point + 24 * 3600 * 10);
  }
  if (time_type == "month") {
    start = time_point - 24 * 3600 * 31 * 6;
    end = checkEnd(time_point + 24 * 3600 * 10);
  }
  if (time_type == "year") {
    start = time_point - 24 * 3600 * 365 * 2;
    end = checkEnd(time_point + 24 * 3600 * 10);
  }
  return { start: start, end: end };
}

function getByteLen(str) {
  var len = 0;
  for (var i = 0; i < str.length; i++) {
    var ch = str.charCodeAt(i);
    if (ch >= 0 && ch <= 128) {
      len += 1;
    } else {
      len += 2;
    }
  }
  return len;
}

function getTimeByType(tm, timeType) {
  if (tm < 100) {
    return "--";
  }
  let t = moment(tm * 1000).format("YYYY-MM-DD HH:mm");
  if (timeType == "hour") {
    t = moment(tm * 1000).format("YYYY-MM-DD HH");
  }
  if (timeType == "day") {
    t = moment(tm * 1000).format("YYYY-MM-DD");
  }
  if (timeType == "week") {
    t =
      moment(tm * 1000).format("YYYY-MM-DD") +
      " -- " +
      moment(tm * 1000 + 3600 * 24 * 6 * 1000).format("MM-DD");
  }
  if (timeType == "period") {
    t = moment(tm * 1000).format("YYYY-MM-DD");
  }
  if (timeType == "month") {
    t = moment(tm * 1000).format("YYYY-MM");
  }
  if (timeType == "year") {
    t = moment(tm * 1000).format("YYYY");
  }
  return t;
}

function calcMapcolor(pmcolor_ratio, dataType, draw_data) {
  let max_ratio = 0;
  let min_ratio = 0;
  if (dataType == "pm25") {
    max_ratio = pmcolor_ratio.pm25_max_ratio;
    min_ratio = pmcolor_ratio.pm25_min_ratio;
  } else {
    max_ratio = pmcolor_ratio.pm10_max_ratio;
    min_ratio = pmcolor_ratio.pm10_min_ratio;
  }
  let data_len = draw_data.length;
  let max_idx = parseInt(data_len * max_ratio);
  let min_idx = parseInt(data_len * (1 - min_ratio));
  let max = draw_data[max_idx].count;
  let min = draw_data[min_idx].count;
  if (!draw_data[max_idx].count) {
    max = draw_data[max_idx][1];
    min = draw_data[min_idx][1];
  }

  if (!max) {
    max = 700;
  }
  if (!min) {
    min = 0;
  }
  max = Math.round(max);
  min = Math.round(min);
  return { min: min, max: max };
}

function getWindRecentTime(t) {
  let mo = moment(t);
  let h = mo.hour();
  let n_h = parseInt(h / 6) * 6;
  return mo.format(`YYYY-MM-DD ${n_h}:00:00`);
}

function addMarker(
  info,
  dataType,
  map,
  data_val,
  inten,
  showName,
  drawCircle,
  circleR,
  isPollution
) {
  var val = "--";
  // 污染指数为0表示没污染,并不是不在线，为null时为没有值，作为不在线的
  if (isPollution) {
    if (data_val || data_val >= 0) {
      val = data_val;
    }
  } else {
    if (data_val && data_val > 0) {
      val = data_val;
    }
  }
  var ic = "";
  if (info.station_level) {
    var ic = info.station_level + ": ";
  }
  var text = info.name;
  if (info.Name) {
    text = info.Name;
  }
  // if (val){
  text = text + ":" + val;
  // }
  if (!showName) {
    text = val;
    ic = "";
  }
  var width = getByteLen(text) * 7;
  if (width > 10) {
    width = width + 60;
  } else {
    width = 60;
  }
  var arrow_left = width / 2 - 5;
  // var pm25_color = getPMInfo(val,dataType)
  // var pm10_color = getPMInfo(pm10,"pm10")
  // var bg_color = pm25_color.bgcolor
  // let fgcolor = pm25_color.fgcolor
  var bg_color = inten.bgcolor.getColor(val + 0.01);
  var fgcolor = inten.fgcolor.getColor(val + 0.01);
  let zIndex = 10;
  if (val == "--") {
    bg_color = inten.bgcolor.getColor(null);
    fgcolor = inten.fgcolor.getColor(null);
  } else {
    zIndex += parseInt(val * 10);
  }
  /* if (inten && val != '--'){
        if(isPollution) {
            bg_color = inten.bgcolor.getColor(val + 0.01)
            fgcolor = inten.fgcolor.getColor(val + 0.01)
        } else {
            bg_color = inten.bgcolor.getColor(val)
            fgcolor = inten.fgcolor.getColor(val)
        }
    } */

  var htm =
    "<div style='position: absolute;border-radius: 5px;border: 2px solid " +
    "black" +
    "; color: white;transform:translate(-50%,-50%);bottom:5px;width:" +
    width +
    "px' >" +
    "<div style='background-color:" +
    bg_color +
    ";text-align: center;padding: 2px; margin: 0px; height: 20px; border-radius: 2px;color:" +
    fgcolor +
    "'>" +
    ic +
    "<span style='display:inline-block;" +
    "color:" +
    fgcolor +
    "'>" +
    text +
    "</span></div>" +
    "<div class='arrow'" +
    " style=\"background: url('http://iot.novaecs.com/f/v1/img/bdmap/label.png') 0px 0px no-repeat; position: absolute; width:6px; height: 15px; top: 22px; left: " +
    arrow_left +
    'px; overflow: hidden;">' +
    "</div></div>";
  // var gcj = coordtransform.wgs84togcj02(info.Lng,info.Lat)
  // var bd = coordtransform.gcj02tobd09(gcj[0],gcj[1])
  // var p = new BMap.Point(bd[0], bd[1]);
  var p = new BMap.Point(info.Lng, info.Lat);

  var marker = new BMapLib.RichMarker(htm, p, { zIndex: zIndex });
  if (drawCircle) {
    var circleMarker = new BMap.Circle(p, circleR, {
      fillOpacity: 0.001,
      strokeWeight: 3,
      strokeColor: bg_color
    });
    map.addOverlay(circleMarker);
    marker.circleMarker = circleMarker;
  }

  marker.info = info;

  // marker.addEventListener("onclick", function(e) {
  //   alert(e.type); //点击Marker时，派发事件的接口 --{"target : {BMap.Overlay} 触发事件的元素, "type：{String} 事件类型}
  // });
  map.addOverlay(marker);
  return marker;
}

function addOrUpdateChart({ chart, series }) {
  let id = series.id;
  let old = chart.get(id);
  if (old) {
    old.update(series);
  } else {
    chart.addSeries(series);
  }
}

function clearChart(chart) {
  let ids = ["compare1_pm25", "compare1_pm10", "pm25", "pm10"];
  for (let id of ids) {
    let series = chart.get(id);
    if (series) {
      series.remove();
    }
  }
}

function validFilter(v, type=null) {
  if (type == 'pm10_PoP') {
    if (isCheckNumber(v)) {
      return v;
    } else {
      return "--";
    }
  } else{
    if (v && v > 0) {
      return v;
    } else {
      return "--";
    }
  }
}

function lineDataTo24H(data_list) {
  let hour_data = {};
  let seriesData = [];
  let hours = [];
  for (let i = 0; i < 24; i++) {
    hour_data[i] = [];
    hours.push(i);
  }
  for (let i of data_list) {
    let t = i.x;
    let hour = moment(i.x).hours();
    let val = i.y;
    hour_data[hour].push(val);
  }
  for (let i in hour_data) {
    let d = hour_data[i];
    let val = null;

    if (d.length > 0) {
      val = Math.round(_.mean(d));
    }
    seriesData.push(val);
  }
  return seriesData;
}

function csvObject(csv) {
  var lines = csv.split("\n");

  var result = [];

  var headers = lines[0].split(",");

  for (var i = 1; i < lines.length; i++) {
    var obj = {};
    var currentline = lines[i].split(",");

    for (var j = 0; j < headers.length; j++) {
      obj[headers[j]] = currentline[j];
    }

    result.push(obj);
  }

  //return result; //JavaScript object
  return result; //JSON
}

function GetDistance(lat1, lng1, lat2, lng2) {
  var radLat1 = (lat1 * Math.PI) / 180.0;
  var radLat2 = (lat2 * Math.PI) / 180.0;
  var a = radLat1 - radLat2;
  var b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
  var s =
    2 *
    Math.asin(
      Math.sqrt(
        Math.pow(Math.sin(a / 2), 2) +
          Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
      )
    );
  s = s * 6378.137; // EARTH_RADIUS;
  s = Math.round(s * 10000) / 10000;
  return s;
}


function GetRequest(name) {
  return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
}

function isCheckNumber(value) {
  return /^-?\d+(\.\d+)?$/.test(value);
}

export {
  getBoundary,
  drawBoundary,
  GetQueryString,
  fullPage,
  openMapWindow,
  time_add_by_type,
  get_recent_start,
  check_time_type,
  check_time_range,
  getByteLen,
  addMarker,
  checkEnd,
  get_time_range_by_point,
  getTimeByType,
  calcMapcolor,
  getWindRecentTime,
  addOrUpdateChart,
  clearChart,
  validFilter,
  lineDataTo24H,
  csvObject,
  GetDistance,
  GetRequest,
  isCheckNumber
};



// WEBPACK FOOTER //
// ./src/utils/util.js